<template>
  <v-card class="rounded-card ma-2" flat outlined>
    <v-card-title>{{ $t('models.dashboard.attributes.summary') }}</v-card-title>
    <v-data-table
      class="summary-table"
      :headers="headers"
      :items="items"
      hide-default-footer
      height="300px"
      fixed-header
      :items-per-page="-1"
      :no-data-text="$t('messages.emptyState', { entity: 'Attendance Records' })"
      :no-results-text="$t('messages.emptyState', { entity: 'Attendance Records' })"
      flat
    >
      <template v-slot:item.totalViolations="{ item }">
        {{ item.totalViolations }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'SummaryTable',
  props: {
    attendanceItems: {type: Array, required: true}
  },
  computed: {
    items() {
      const records = Array.isArray(this.attendanceItems) ? this.attendanceItems : [];
      return records.map((record) => ({
        id: record.id,
        fullName: record.fullName,
        totalViolations: (record.violations || []).length
      }));
    },
    headers() {
      return [
        {text: this.$t('models.dashboard.attributes.employee'), value: 'fullName'},
        {text: this.$t('models.dashboard.attributes.totalViolations'), value: 'totalViolations'}
      ];
    }
  }
};
</script>


